export class FetchActions {
  static readonly type = '[History] Fetch';

  constructor(public link: string, public concat: boolean, public start: string, public end: string) {
  }
}

export class FetchMin {
  static readonly type = '[History] FetchMin';

  constructor() {
  }
}


export class AddAction {

  static readonly type = '[History] Add';

  constructor(public payload: any) {
  }
}

